module.exports = __webpack_public_path__ + "media/images/flags/vc-56dc1f92beb71bf5373a5b82e6f050c2.svg";